var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPicBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2778 10.35C21.2778 6.13125 18.8778 4.5 16.4889 4.5C14.4444 4.5 13.4111 5.1525 12.3889 6.44625C11.3667 5.1525 10.3333 4.5 8.28889 4.5C5.9 4.5 3.5 6.12 3.5 10.35C3.5 13.6125 7.25556 18.135 12.3778 20.25C17.5 18.135 21.2556 13.6125 21.2556 10.35H21.2778Z",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicBlack);
export default __webpack_public_path__ + "static/media/PIC_black.4ddc24fda0e6e6297cf2166824680f6f.svg";
export { ForwardRef as ReactComponent };